import Vue from 'vue'
import Router from 'vue-router'

import MHeader from '@/common/nav'
import WebHeader from '@/common/webapp_nav'
import MFooter from '@/common/footer'
import MBanner from '@/common/bannerBg'

// import Home from '@/components/home'
Vue.use(Router)

let router =  new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: resolve => require(["@/components/home"],resolve),
      name: 'HOME'
    },
    {
      path: '/series/:seriesName',
      component: resolve => require(["@/components/series"],resolve),
      name: 'SERIES'
    },
    {
      path: '/goodsDetail/:id',
      component: resolve => require(["@/components/goodsDetail"],resolve),
      name: 'GOODSDETAIL'
    },
    {
      path: '/gifts',
      component: resolve => require(["@/components/gifts"],resolve),
      name: 'GIFTS'
    },
    {
      path: '/news',
      component: resolve => require(["@/components/news"],resolve),
      name: 'NEWS'
    },
    {
      path: '/newsDetail/:newsName',
      component: resolve => require(["@/components/newsDetail"],resolve),
      name: 'newsDetail'
    },
    {
      path: '/shop',
      component: resolve => require(["@/components/shop"],resolve),
      name: 'SHOP'
    },
    {
      path: '/brand',
      component: resolve => require(["@/components/brand"],resolve),
      name: 'BRAND'
    },
    {
      path: '/contact',
      component: resolve => require(["@/components/contact"],resolve),
      name: 'CONTACT'
    },
    {
      path: '/terms&condition',
      component: resolve => require(["@/components/termsCondition"],resolve)
    },
    {
      path: '/vandomm',
      component: resolve => require(["@/components/vandomm"],resolve)
    },
    {
      path: '/info',
      component: resolve => require(["@/components/info"],resolve)
    },
    {
      path: '/*',
      redirect: '/home'
    }
  ]
})

router.afterEach((to, from) => {
  if(document.documentElement.scrollTop) document.documentElement.scrollTop = 0 ;
  if(document.body.scrollTop) document.body.scrollTop  = 0;
})
Vue.component('m-header',MHeader);
Vue.component('web-header',WebHeader);
Vue.component('m-footer', MFooter);
Vue.component('m-banner', MBanner);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js